import { unstable_editorExperimentParam } from '@atlaskit/tmp-editor-statsig/experiments';

import { createRequestGenerator } from './generator';
import { TriggerContext } from './types';

export async function canNudgeFullPageImproveWriting({
	proactiveAIApiUrl,
	product,
	context,
}: {
	proactiveAIApiUrl: string;
	product: string;
	context: TriggerContext;
}) {
	const requestGenerator = createRequestGenerator({
		endpoint: proactiveAIApiUrl,
		product,
		context,
	});

	if (!requestGenerator) {
		return { canNudge: false, confidenceScore: 0 };
	}

	let canNudge = false;
	let confidenceScore: number | undefined = 0;
	for await (const responseState of requestGenerator) {
		switch (responseState.state) {
			case 'cached':
			case 'parsed': {
				const recommendations = responseState.recommendations;

				const replaceParagraphTransform = recommendations.find(
					(r) => r.transformType === 'REPLACE_PAGE',
				);
				const minimalScore = unstable_editorExperimentParam(
					'platform_editor_ai_proactive_ai_nudge_score',
					'score',
					{
						defaultValue: 0,
						typeGuard: (value: unknown): value is number => typeof value === 'number',
					},
				);

				confidenceScore = replaceParagraphTransform?.score;
				canNudge = !!(
					replaceParagraphTransform &&
					replaceParagraphTransform.transformContent &&
					(replaceParagraphTransform.score === undefined ||
						replaceParagraphTransform.score >= minimalScore)
				);

				break;
			}
		}
	}

	return { canNudge, confidenceScore };
}
